import {createRoutine} from "redux-saga-routines";

export const setSessionIdRoutine = createRoutine('SET_SESSION_ID_ROUTINE');
